import getAppSite from 'utils/getAppSite';

const showKeyUpdateTime = (source?: string | null): boolean =>
  getAppSite() !== 'usa' && !source?.includes('gov.uk/government/news');

export default showKeyUpdateTime;
